import _ from 'lodash';

// Sổ nháp điều hướng non-reactive, thay cho goto[KEY_REDUX.SUPPORT_PAGE]. Xem spec §3.
// Default có activeTab/searchValue/requestType từ initialState, còn `tab` (thứ support.tsx thực
// sự đọc/ghi) không có trong default — giữ đúng bất đối xứng của code cũ, không "sửa cho khớp".
const supportNavigationState: Record<string, any> = {};

/**
 * Restores the support navigation state to its defaults so the support page reopens clean. Deletes every key on the shared supportNavigationState object, then assigns the first tab, an empty search value and the All requests type.
 *
 * @returns Nothing.
 */
const resetSupportNavigationState = () => {
  _.forEach(_.keys(supportNavigationState), (key) => {
    delete supportNavigationState[key];
  });
  _.assign(supportNavigationState, {
    activeTab: '1',
    searchValue: '',
    requestType: 'All requests',
  });
};

resetSupportNavigationState();

export { supportNavigationState, resetSupportNavigationState };
